<div class="flex items-center justify-between gap-4">
  <span class="flex-1 text-white">{{ data.message }}</span>
  <div class="flex items-center gap-2">
    <div class="relative flex h-8 w-8 items-center justify-center">
      <svg
        class="countdown-svg absolute inset-0 h-full w-full -rotate-90"
        viewBox="0 0 36 36"
      >
        <circle
          class="countdown-track"
          cx="18"
          cy="18"
          r="16"
          pathLength="100"
        />
        <circle
          class="countdown-progress"
          cx="18"
          cy="18"
          r="16"
          pathLength="100"
          [style.stroke-dashoffset]="progressOffset()"
        />
      </svg>
      <span class="z-10 text-xs font-medium text-white">{{
        secondsRemaining()
      }}</span>
    </div>
    <button mat-flat-button color="primary" (click)="undo()">
      {{ data.actionLabel || 'Undo' }}
    </button>
  </div>
</div>
